/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Company_Taxpayer_Id_PlaceholderInputs */

const es_co2_signup_company_taxpayer_id_placeholder = /** @type {(inputs: Signup_Company_Taxpayer_Id_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`900123456`)
};

/**

* @param {Signup_Company_Taxpayer_Id_PlaceholderInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const signup_company_taxpayer_id_placeholder = /** @type {((inputs?: Signup_Company_Taxpayer_Id_PlaceholderInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Company_Taxpayer_Id_PlaceholderInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_signup_company_taxpayer_id_placeholder(inputs)
});